import React, { useEffect } from 'react';
import Breadcrumb from '../Breadcrumb';
import Section from '../Section';
import AboutUsSection from '../Section/AboutSection';
import TestimonialSection from '../Section/TestimonialSection';
import { PAGE_SEO } from '../../config/seo';
import { useSEO } from '../../helpers/useSEO';
import ServiceSectionStyle2 from '../Section/ServiceSection/ServiceSectionStyle2';

const serviceData = [
  {
    iconUrl: '/images/icons/service_icon_1.svg',
    title: 'Études structurelles',
    subTitle:
      'Conception et dimensionnement des structures béton armé, métalliques et mixtes pour tous types de bâtiments.',
    imgUrl: '/images/service1.svg',
    href: '/service/services-details',
  },
  {
    iconUrl: '/images/icons/service_icon_2.svg',
    title: 'Suivi et pilotage de chantier',
    subTitle:
      'Notre équipe assure un suivi personnalisé sur site, incluant la supervision des travaux, l\'assistance technique et le contrôle rigoureux de l\'exécution.',
    imgUrl: '/images/project_1.jpeg',
    href: '/service/services-details',
  },
  {
    iconUrl: '/images/icons/service_icon_3.svg',
    title: "Études d'exécution",
    subTitle:
      'Nous réalisons les plans d\'exécution, la synthèse technique et la coordination de votre chantier.',
    imgUrl: '/images/service3.svg',
    href: '/service/services-details',
  },
  {
    iconUrl: '/images/icons/service_icon_4.svg',
    title: 'Optimisation des coûts de construction',
    subTitle:
      'Recherche de solutions techniques permettant de réduire les coûts sans compromettre la qualité.',
    imgUrl: '/images/service4.svg',
    href: '/service/services-details',
  },
];

const testimonialData = [
  {
    imgUrl: '/images/avatar_1.png',
    rating: '5',
    desc: 'Une équipe très professionnelle et réactive. Les études techniques étaient précises et parfaitement adaptées à notre projet. Le suivi a été sérieux du début à la fin.',
    name: 'Nour Ben Youssef',
    designation: 'Client',
  },
  {
    imgUrl: '/images/avatar_2.png',
    rating: '5',
    desc: 'Excellent bureau d\'études. Les solutions proposées ont permis d\'optimiser les coûts tout en respectant les normes de construction. Une vraie valeur ajoutée.',
    name: 'Amine Trabelsi',
    designation: 'Client',
  },
  {
    imgUrl: '/images/avatar_3.png',
    rating: '5',
    desc: 'Un accompagnement rigoureux et un suivi de chantier impeccable. L\'équipe maîtrise parfaitement les aspects techniques et organisationnels.',
    name: 'Leila Bouzid',
    designation: 'Client',
  },
  {
    imgUrl: '/images/avatar_4.png',
    rating: '5',
    desc: 'Nexting Études a su comprendre nos besoins et proposer des solutions fiables. Nous recommandons leurs services sans hésitation.',
    name: 'Sami Jaziri',
    designation: 'Client',
  },
];

export default function AboutPage() {
  useSEO(PAGE_SEO.about);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <Breadcrumb title="À propos de nous" bgUrl="/images/about.jpg" />

      <Section
        pt="135"
        ptLg="75"
        pb="140"
        pbLg="80"
        className="position-relative"
      >
        <AboutUsSection
          thumbUrl="/images/a_propos_1.svg"
          experienceBgUrl="/images/a_propos_2.svg"
          experienceIconUrl="/images/experience_icon.svg"
          experienceNumber="15"
          experienceTitle="Années d'expérience"
          sectionTitleUp="A Propos de nous"
          sectionTitle='Pourquoi choisir <span className="text-accent">Nexting Études</span> ?'
          sectionSubTitle="Nexting Études est un bureau d'études spécialisé dans l'ingénierie du bâtiment et les projets de construction civile.<br><br>Nous intervenons à chaque étape du projet : conception, études techniques, calculs de structure, coordination et suivi d'exécution."
          grothTitle="Expertise technique reconnue"
          grothPercentage="90"
          featureList={[
            {
              title: 'Accompagnement personnalisé',
              subTitle:
                'Chaque projet bénéficie d\'une approche adaptée à vos besoins et contraintes.',
            },
            {
              title: 'Conformité réglementaire',
              subTitle:
                'Des études conformes aux normes techniques et de sécurité en vigueur.',
            },
          ]}
          btnText="Demander une consultation"
          btnUrl="/contact"
        />
      </Section>

      <Section pt="140" ptLg="80" pb="115" pbLg="55">
        <ServiceSectionStyle2
          sectionTitleUp="Nos Services"
          sectionTitle="Une expertise au service de vos ambitions"
          data={serviceData}
          compact
        />
      </Section>

      <Section
        pt="110"
        ptLg="55"
        pb="140"
        pbLg="80"
        className="cs_section_with_shape position-relative overflow-hidden"
        style={{ backgroundImage: `url(${'/images/testimonial_bg.jpeg'})` }}
      >
        <TestimonialSection
          sectionTitleUp="Témoignages clients"
          sectionTitle="Que disent-ils ?"
          sectionSubTitle="Les dretours de nos clients reflètent notre engagement à fournir des études techniques fiables, précises et adaptées à chaque projet."
          data={testimonialData}
        />
      </Section>
    </>
  );
}
